import { Component, Input, input } from '@angular/core';

@Component({
    selector: 'el-heading',
    templateUrl: './el-heading.component.html',
    styleUrls: ['./el-heading.component.scss'],
    standalone: false
})
export class ElHeadingComponent {
  /**
   * Main text
   */
  readonly text = input<string>(undefined);

  /**
   * Sub text, optional
   */
  @Input() subtext: string='';

  /**
   * Add extra class to text
   */
  readonly textClass = input<string>(undefined);

  /**
   * Add extra class to sub text
   */
   readonly subTextClass = input<string>(undefined);
}

/**
 * Used in Settings Security
 * Used in Settings Legrand
 */
